import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "src/routes/Loadable";

const CategoryList = Loadable(
  lazy(() => import("src/pages/admin/categoryList"))
);
const VideoTraining = Loadable(
  lazy(() => import("src/pages/admin/subscriptionVdo/index"))
);
const CryptoCurrencies = Loadable(
  lazy(() => import("src/pages/admin/subscriptionVdo/index"))
);
const AutomaticTrading = Loadable(
  lazy(() => import("src/pages/admin/subscriptionVdo/index"))
);

const Staking = Loadable(
  lazy(() => import("src/pages/admin/subscriptionVdo/index"))
);

const Stocks = Loadable(
  lazy(() => import("src/pages/admin/subscriptionVdo/index"))
);

const FractionalRealEstate = Loadable(
  lazy(() => import("src/pages/admin/subscriptionVdo/index"))
);
const NetworkMarketing = Loadable(
  lazy(() => import("src/pages/admin/subscriptionVdo/index"))
);

const SubscriptionVdoEng = [
  {
    path: "subscriptionEng",
    children: [
      { index: true, element: <Navigate to="categories" /> },
      {
        path: "categories",
        element: <CategoryList lang={"en"} />,
      },
      {
        path: ":subscriptions_id",
        element: <VideoTraining lang={"en"} />,
      },
      // {
      //   path: "video-training",
      //   element: (
      //     <VideoTraining   />
      //   ),
      // },
    ],
  },
];

export default SubscriptionVdoEng;
